/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserRolesRouteImport } from './routes/user-roles'
import { Route as TranslationsRouteImport } from './routes/translations'
import { Route as SystemSettingsRouteImport } from './routes/system-settings'
import { Route as SupportRouteImport } from './routes/support'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as BillingIssuesRouteImport } from './routes/billing-issues'
import { Route as AccessRequestsRouteImport } from './routes/access-requests'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as SalesIndexRouteImport } from './routes/sales/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as CrmIndexRouteImport } from './routes/crm/index'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as SalesOrganizationIdRouteImport } from './routes/sales/$organizationId'
import { Route as OrganizationsOrganizationIdRouteImport } from './routes/organizations/$organizationId'
import { Route as CrmTasksRouteImport } from './routes/crm/tasks'
import { Route as CrmSettingsRouteImport } from './routes/crm/settings'
import { Route as CrmReportsRouteImport } from './routes/crm/reports'
import { Route as CrmOrganizationsIndexRouteImport } from './routes/crm/organizations/index'
import { Route as CrmOpportunitiesIndexRouteImport } from './routes/crm/opportunities/index'
import { Route as CrmContactsIndexRouteImport } from './routes/crm/contacts/index'
import { Route as CrmOrganizationsOrganizationIdRouteImport } from './routes/crm/organizations/$organizationId'
import { Route as CrmOpportunitiesOpportunityIdRouteImport } from './routes/crm/opportunities/$opportunityId'
import { Route as CrmContactsContactIdRouteImport } from './routes/crm/contacts/$contactId'

const UserRolesRoute = UserRolesRouteImport.update({
  id: '/user-roles',
  path: '/user-roles',
  getParentRoute: () => rootRouteImport,
} as any)
const TranslationsRoute = TranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/system-settings',
  path: '/system-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIssuesRoute = BillingIssuesRouteImport.update({
  id: '/billing-issues',
  path: '/billing-issues',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRequestsRoute = AccessRequestsRouteImport.update({
  id: '/access-requests',
  path: '/access-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmIndexRoute = CrmIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CrmRoute,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesOrganizationIdRoute = SalesOrganizationIdRouteImport.update({
  id: '/sales/$organizationId',
  path: '/sales/$organizationId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsOrganizationIdRoute =
  OrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CrmTasksRoute = CrmTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => CrmRoute,
} as any)
const CrmSettingsRoute = CrmSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CrmRoute,
} as any)
const CrmReportsRoute = CrmReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => CrmRoute,
} as any)
const CrmOrganizationsIndexRoute = CrmOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => CrmRoute,
} as any)
const CrmOpportunitiesIndexRoute = CrmOpportunitiesIndexRouteImport.update({
  id: '/opportunities/',
  path: '/opportunities/',
  getParentRoute: () => CrmRoute,
} as any)
const CrmContactsIndexRoute = CrmContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => CrmRoute,
} as any)
const CrmOrganizationsOrganizationIdRoute =
  CrmOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => CrmRoute,
  } as any)
const CrmOpportunitiesOpportunityIdRoute =
  CrmOpportunitiesOpportunityIdRouteImport.update({
    id: '/opportunities/$opportunityId',
    path: '/opportunities/$opportunityId',
    getParentRoute: () => CrmRoute,
  } as any)
const CrmContactsContactIdRoute = CrmContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => CrmRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-requests': typeof AccessRequestsRoute
  '/billing-issues': typeof BillingIssuesRoute
  '/crm': typeof CrmRouteWithChildren
  '/support': typeof SupportRoute
  '/system-settings': typeof SystemSettingsRoute
  '/translations': typeof TranslationsRoute
  '/user-roles': typeof UserRolesRoute
  '/crm/reports': typeof CrmReportsRoute
  '/crm/settings': typeof CrmSettingsRoute
  '/crm/tasks': typeof CrmTasksRoute
  '/organizations/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/sales/$organizationId': typeof SalesOrganizationIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/crm/': typeof CrmIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/crm/contacts/$contactId': typeof CrmContactsContactIdRoute
  '/crm/opportunities/$opportunityId': typeof CrmOpportunitiesOpportunityIdRoute
  '/crm/organizations/$organizationId': typeof CrmOrganizationsOrganizationIdRoute
  '/crm/contacts/': typeof CrmContactsIndexRoute
  '/crm/opportunities/': typeof CrmOpportunitiesIndexRoute
  '/crm/organizations/': typeof CrmOrganizationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-requests': typeof AccessRequestsRoute
  '/billing-issues': typeof BillingIssuesRoute
  '/support': typeof SupportRoute
  '/system-settings': typeof SystemSettingsRoute
  '/translations': typeof TranslationsRoute
  '/user-roles': typeof UserRolesRoute
  '/crm/reports': typeof CrmReportsRoute
  '/crm/settings': typeof CrmSettingsRoute
  '/crm/tasks': typeof CrmTasksRoute
  '/organizations/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/sales/$organizationId': typeof SalesOrganizationIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/crm': typeof CrmIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/sales': typeof SalesIndexRoute
  '/users': typeof UsersIndexRoute
  '/crm/contacts/$contactId': typeof CrmContactsContactIdRoute
  '/crm/opportunities/$opportunityId': typeof CrmOpportunitiesOpportunityIdRoute
  '/crm/organizations/$organizationId': typeof CrmOrganizationsOrganizationIdRoute
  '/crm/contacts': typeof CrmContactsIndexRoute
  '/crm/opportunities': typeof CrmOpportunitiesIndexRoute
  '/crm/organizations': typeof CrmOrganizationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-requests': typeof AccessRequestsRoute
  '/billing-issues': typeof BillingIssuesRoute
  '/crm': typeof CrmRouteWithChildren
  '/support': typeof SupportRoute
  '/system-settings': typeof SystemSettingsRoute
  '/translations': typeof TranslationsRoute
  '/user-roles': typeof UserRolesRoute
  '/crm/reports': typeof CrmReportsRoute
  '/crm/settings': typeof CrmSettingsRoute
  '/crm/tasks': typeof CrmTasksRoute
  '/organizations/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/sales/$organizationId': typeof SalesOrganizationIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/crm/': typeof CrmIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/crm/contacts/$contactId': typeof CrmContactsContactIdRoute
  '/crm/opportunities/$opportunityId': typeof CrmOpportunitiesOpportunityIdRoute
  '/crm/organizations/$organizationId': typeof CrmOrganizationsOrganizationIdRoute
  '/crm/contacts/': typeof CrmContactsIndexRoute
  '/crm/opportunities/': typeof CrmOpportunitiesIndexRoute
  '/crm/organizations/': typeof CrmOrganizationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-requests'
    | '/billing-issues'
    | '/crm'
    | '/support'
    | '/system-settings'
    | '/translations'
    | '/user-roles'
    | '/crm/reports'
    | '/crm/settings'
    | '/crm/tasks'
    | '/organizations/$organizationId'
    | '/sales/$organizationId'
    | '/users/$userId'
    | '/crm/'
    | '/organizations/'
    | '/sales/'
    | '/users/'
    | '/crm/contacts/$contactId'
    | '/crm/opportunities/$opportunityId'
    | '/crm/organizations/$organizationId'
    | '/crm/contacts/'
    | '/crm/opportunities/'
    | '/crm/organizations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-requests'
    | '/billing-issues'
    | '/support'
    | '/system-settings'
    | '/translations'
    | '/user-roles'
    | '/crm/reports'
    | '/crm/settings'
    | '/crm/tasks'
    | '/organizations/$organizationId'
    | '/sales/$organizationId'
    | '/users/$userId'
    | '/crm'
    | '/organizations'
    | '/sales'
    | '/users'
    | '/crm/contacts/$contactId'
    | '/crm/opportunities/$opportunityId'
    | '/crm/organizations/$organizationId'
    | '/crm/contacts'
    | '/crm/opportunities'
    | '/crm/organizations'
  id:
    | '__root__'
    | '/'
    | '/access-requests'
    | '/billing-issues'
    | '/crm'
    | '/support'
    | '/system-settings'
    | '/translations'
    | '/user-roles'
    | '/crm/reports'
    | '/crm/settings'
    | '/crm/tasks'
    | '/organizations/$organizationId'
    | '/sales/$organizationId'
    | '/users/$userId'
    | '/crm/'
    | '/organizations/'
    | '/sales/'
    | '/users/'
    | '/crm/contacts/$contactId'
    | '/crm/opportunities/$opportunityId'
    | '/crm/organizations/$organizationId'
    | '/crm/contacts/'
    | '/crm/opportunities/'
    | '/crm/organizations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessRequestsRoute: typeof AccessRequestsRoute
  BillingIssuesRoute: typeof BillingIssuesRoute
  CrmRoute: typeof CrmRouteWithChildren
  SupportRoute: typeof SupportRoute
  SystemSettingsRoute: typeof SystemSettingsRoute
  TranslationsRoute: typeof TranslationsRoute
  UserRolesRoute: typeof UserRolesRoute
  OrganizationsOrganizationIdRoute: typeof OrganizationsOrganizationIdRoute
  SalesOrganizationIdRoute: typeof SalesOrganizationIdRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  SalesIndexRoute: typeof SalesIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user-roles': {
      id: '/user-roles'
      path: '/user-roles'
      fullPath: '/user-roles'
      preLoaderRoute: typeof UserRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/translations': {
      id: '/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof TranslationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-settings': {
      id: '/system-settings'
      path: '/system-settings'
      fullPath: '/system-settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing-issues': {
      id: '/billing-issues'
      path: '/billing-issues'
      fullPath: '/billing-issues'
      preLoaderRoute: typeof BillingIssuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-requests': {
      id: '/access-requests'
      path: '/access-requests'
      fullPath: '/access-requests'
      preLoaderRoute: typeof AccessRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/': {
      id: '/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/': {
      id: '/crm/'
      path: '/'
      fullPath: '/crm/'
      preLoaderRoute: typeof CrmIndexRouteImport
      parentRoute: typeof CrmRoute
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/$organizationId': {
      id: '/sales/$organizationId'
      path: '/sales/$organizationId'
      fullPath: '/sales/$organizationId'
      preLoaderRoute: typeof SalesOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$organizationId': {
      id: '/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof OrganizationsOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/tasks': {
      id: '/crm/tasks'
      path: '/tasks'
      fullPath: '/crm/tasks'
      preLoaderRoute: typeof CrmTasksRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/settings': {
      id: '/crm/settings'
      path: '/settings'
      fullPath: '/crm/settings'
      preLoaderRoute: typeof CrmSettingsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/reports': {
      id: '/crm/reports'
      path: '/reports'
      fullPath: '/crm/reports'
      preLoaderRoute: typeof CrmReportsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/organizations/': {
      id: '/crm/organizations/'
      path: '/organizations'
      fullPath: '/crm/organizations/'
      preLoaderRoute: typeof CrmOrganizationsIndexRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/opportunities/': {
      id: '/crm/opportunities/'
      path: '/opportunities'
      fullPath: '/crm/opportunities/'
      preLoaderRoute: typeof CrmOpportunitiesIndexRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/contacts/': {
      id: '/crm/contacts/'
      path: '/contacts'
      fullPath: '/crm/contacts/'
      preLoaderRoute: typeof CrmContactsIndexRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/organizations/$organizationId': {
      id: '/crm/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/crm/organizations/$organizationId'
      preLoaderRoute: typeof CrmOrganizationsOrganizationIdRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/opportunities/$opportunityId': {
      id: '/crm/opportunities/$opportunityId'
      path: '/opportunities/$opportunityId'
      fullPath: '/crm/opportunities/$opportunityId'
      preLoaderRoute: typeof CrmOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/contacts/$contactId': {
      id: '/crm/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/crm/contacts/$contactId'
      preLoaderRoute: typeof CrmContactsContactIdRouteImport
      parentRoute: typeof CrmRoute
    }
  }
}

interface CrmRouteChildren {
  CrmReportsRoute: typeof CrmReportsRoute
  CrmSettingsRoute: typeof CrmSettingsRoute
  CrmTasksRoute: typeof CrmTasksRoute
  CrmIndexRoute: typeof CrmIndexRoute
  CrmContactsContactIdRoute: typeof CrmContactsContactIdRoute
  CrmOpportunitiesOpportunityIdRoute: typeof CrmOpportunitiesOpportunityIdRoute
  CrmOrganizationsOrganizationIdRoute: typeof CrmOrganizationsOrganizationIdRoute
  CrmContactsIndexRoute: typeof CrmContactsIndexRoute
  CrmOpportunitiesIndexRoute: typeof CrmOpportunitiesIndexRoute
  CrmOrganizationsIndexRoute: typeof CrmOrganizationsIndexRoute
}

const CrmRouteChildren: CrmRouteChildren = {
  CrmReportsRoute: CrmReportsRoute,
  CrmSettingsRoute: CrmSettingsRoute,
  CrmTasksRoute: CrmTasksRoute,
  CrmIndexRoute: CrmIndexRoute,
  CrmContactsContactIdRoute: CrmContactsContactIdRoute,
  CrmOpportunitiesOpportunityIdRoute: CrmOpportunitiesOpportunityIdRoute,
  CrmOrganizationsOrganizationIdRoute: CrmOrganizationsOrganizationIdRoute,
  CrmContactsIndexRoute: CrmContactsIndexRoute,
  CrmOpportunitiesIndexRoute: CrmOpportunitiesIndexRoute,
  CrmOrganizationsIndexRoute: CrmOrganizationsIndexRoute,
}

const CrmRouteWithChildren = CrmRoute._addFileChildren(CrmRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRequestsRoute: AccessRequestsRoute,
  BillingIssuesRoute: BillingIssuesRoute,
  CrmRoute: CrmRouteWithChildren,
  SupportRoute: SupportRoute,
  SystemSettingsRoute: SystemSettingsRoute,
  TranslationsRoute: TranslationsRoute,
  UserRolesRoute: UserRolesRoute,
  OrganizationsOrganizationIdRoute: OrganizationsOrganizationIdRoute,
  SalesOrganizationIdRoute: SalesOrganizationIdRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  SalesIndexRoute: SalesIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
